import React from "react";

/**
 * Error Boundary to catch React errors including DOM manipulation issues
 * These errors commonly occur when third-party scripts modify the DOM
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a DOM manipulation error that can be ignored
    const errorMessage = error?.message || "";
    const isDOMError =
      errorMessage.includes("removeChild") ||
      errorMessage.includes("insertBefore") ||
      errorMessage.includes("appendChild") ||
      errorMessage.includes("NotFoundError");

    // For DOM errors caused by third-party scripts, don't show error UI
    if (isDOMError) {
      console.warn("DOM manipulation error caught (likely from third-party scripts):", errorMessage);
      return { hasError: false, error: null };
    }

    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const errorMessage = error?.message || "";
    const isDOMError =
      errorMessage.includes("removeChild") ||
      errorMessage.includes("insertBefore") ||
      errorMessage.includes("appendChild") ||
      errorMessage.includes("NotFoundError");

    if (!isDOMError) {
      console.error("Application error:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black flex items-center justify-center p-4">
          <div className="text-center max-w-md bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-xl shadow-[0_0_50px_rgba(0,0,0,0.5)]">
            <div className="w-20 h-20 bg-gradient-to-br from-red-500/20 to-red-500/5 rounded-full flex items-center justify-center mx-auto mb-6 border border-red-500/20">
              <svg className="w-10 h-10 text-red-400 drop-shadow-md" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>

            <h1 className="text-2xl font-black text-white mb-2 tracking-tight">
              Algo <span className="text-red-400">salió mal</span>
            </h1>

            <p className="text-slate-400 text-sm mb-8 font-medium">
              Ha ocurrido un error inesperado. Por favor, recarga la página.
            </p>

            <button
              onClick={() => window.location.reload()}
              className="w-full px-6 py-4 bg-primary text-white font-black uppercase tracking-widest rounded-xl hover:bg-primary/90 transition-all shadow-[0_0_20px_rgba(59,130,246,0.4)] active:scale-[0.98]"
            >
              Recargar aplicación
            </button>

            <div className="mt-8 flex justify-center items-center gap-2 text-[10px] text-slate-500 font-bold uppercase tracking-widest border-t border-white/10 pt-4">
              Conexo POS Support
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
